<template>
    <div class="game-board">
      <!-- 返回箭头 -->
      <div class="back-arrow" @click="goBack">
      </div>
      <transition name="fade">
        <div v-if="propAlertVisible" class="prop-alert">
          <div style="white-space: nowrap;" class="alert-content">
            对方使用了减时器！
          </div>
        </div>
      </transition>
      <!-- 头部状态区域 -->
      <div class="header" v-if="mode === 'pvp'">
        <div class="player-info">
          <div :class="['player-card', 'black-player']">
            <div class="playtop">
              <div class="avatar-container">
                <img :src="myPlayer === 1 ? user.avatar : ''" alt="头像" v-if="myPlayer === 1 && user.avatar">
                <img src="https://oss.mcloud.moveclub.cn/2025/morentouxiang.png" alt="默认头像" v-else>
              </div>
              <div class="playright">
                <div class="player-name">{{ blackName }}</div>
                <div class="player-color">
                  <div class="color-dot black-dot"></div>
                  <span style="font-size: 12px;opacity: 0.5;">执黑</span>
                </div>
              </div>
            </div>
            <div class="countdown">倒计时：{{ currentPlayer === 1 ? countdown : '--' }}s</div>
          </div>
          <img src="https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/VS.png" class="pvpvs">
          <div :class="['player-card', 'white-player']">
            <div class="playtop">
              <div class="avatar-container">
                <img :src="myPlayer === 2 ? user.avatar : ''" alt="头像" v-if="myPlayer === 2 && user.avatar">
                <img src="https://oss.mcloud.moveclub.cn/2025/morentouxiang.png" alt="默认头像" v-else>
              </div>
              <div class="playright">
                <div class="player-name">{{ whiteName }}</div>
                <div class="player-color">
                  <span class="color-dot white-dot"></span>
                  <span style="font-size: 12px;opacity: 0.5;">执白</span>
                </div>
              </div>
            </div>
            <div class="countdown">倒计时：{{ currentPlayer === 2 ? countdown : '--' }}s</div>
          </div>
        </div>
        
        <div class="prop-icon" @click="showPropConfirm">
          <img src="https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/%E5%87%8F%E6%97%B6%E5%99%A8%402x.png" alt="道具" style="width: 128px; height: 42px;">
          <div class="propnum">（{{propnum}}）</div>
        </div>
        <div class="prop-icon2" @click="showproprule">
          <img style="width: 22px;height: 22px;" src="http://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/305%E4%BF%A1%E6%81%AF-%E5%9C%86%E6%A1%86%402x.png">
        </div>
      </div>
      <div class="header" v-else>
        <div class="player-info" style="padding: 0 40px;">
          <span :class="['player',pvePlayerColor==1?'puser':'ai']">{{ pvePlayerColor==1?firstChar:'' }}</span>
          <span class="vs"></span>
          <span :class="['player',pvePlayerColor==2?'puser':'ai']">{{ pvePlayerColor==2?firstChar:'' }}</span>
        </div>
        <div class="round-status">
          <!-- 局数：第 {{ currentRound }} 局 -->
        </div>
      </div>
      <!-- 棋盘容器 -->
      <div class="board-container">
        <div class="players" v-if="mode === 'pvp'">
          <template v-if="myPlayer === 1">
            <div :class="['b',{ 'active': currentPlayer === 1 }]">你</div>
            <div :class="['w',{ 'active': currentPlayer === 2 }]">对方</div>
          </template>
          <template v-else>
            <div :class="['b2',{ 'active': currentPlayer === 2 }]">你</div>
            <div :class="['w2',{ 'active': currentPlayer === 1 }]">对方</div>
          </template>
        </div>
        <div class="players" v-else>
          <div :class="[pvePlayerColor==1?'b':'']">{{ blackName }}</div>
          <div :class="[pvePlayerColor==2?'w':'']">{{ whiteName }}</div>
        </div>
        <canvas ref="canvas" :width="canvasSize" :height="canvasSize" @click="handleClick"></canvas>
      </div>
      <div class="status-info" v-if="opponentStatus==='offline'">
          对手离线，倒计时：{{ offlineCountdown }}秒
      </div>
      <!-- 显示倒计时 -->
      <!-- <div class="status-info" v-if="mode === 'pvp' && isCounting && !winner">
          落子剩余时间：{{ countdown }}秒
      </div> -->
      <!-- 比赛结束后的重启区域  v-if="winner" -->
      <div class="result" v-if="winner">
        <button :disabled="restartWaiting" @click="restart" :class="{ disabled: restartWaiting }">
        </button>
      </div>
      <van-popup v-model="show" round style="width: 263px; height: 299px;background: transparent;">
        <div class="pop" :style="{'background':'url('+(((currentPlayer==1 && (pvePlayerColor == 1 || myPlayer == 1))||(currentPlayer==2 && (pvePlayerColor == 2 || myPlayer == 2)))?'https://oss.mcloud.moveclub.cn/2025/success.png':'https://oss.mcloud.moveclub.cn/2025/error.png')+') no-repeat','background-size': '100%'}" style="height: 299px;">
          <button style="position: absolute;bottom: 20px;left: 50%;transform: translateX(-50%);" :disabled="restartWaiting" @click="restart" :class="{ disabled: restartWaiting }">
          </button>
        </div>
      </van-popup>

      <van-popup v-model="showPropConfirmPopup" round style="width: 263px; height: 299px;">
        <div class="pop confirm-popup">
          <div class="popup-header">
            <h3>使用道具</h3>
          </div>
          <div class="popicon">
            <img style="width: 72px;height: 75px;" src="https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/usedaoju.png" >
          </div>
          <div class="popup-content">
            <p>是否给对手使用道具？</p>
            <p style="width: 88%;font-size: 12px;color: #FA6400;letter-spacing: 0;text-align: center;font-weight: 400;">该道具将在下一轮对手下子时生效，思考时间减去15秒</p>
          </div>
          <div class="popup-footer">
            <button @click="showPropConfirmPopup = false" class="cancel-btn">取消</button>
            <button @click="confirmUseProp" :class="{ disabled: usingProp }" class="confirm-btn">
              {{ usingProp ? '使用中...' : '确认使用' }}
            </button>
          </div>
        </div>
      </van-popup>

      <van-popup v-model="propruleinfo" :overlay="false" position="top" style="width: 200px;background: #000000;opacity: 0.6;margin: 60px 0 0 160px;border-radius: 12px;">
        <div style="padding: 16px; font-size: 12px;color: #FFFFFF;letter-spacing: 0;line-height: 18px;font-weight: 400;">使用减时器，可给对手倒计时减少15秒思考时间。使用本道具，将在下一轮下子时生效。</div>
      </van-popup>
    </div>
  </template>
  
  <script>
  import io from 'socket.io-client'
  import { Popup } from 'vant';
  import axios from 'axios'
  export default {
    name: 'GameBoard',
    components: {
      vanPopup: Popup
    },
    data() {
      return {
        canvasSize: 338,
        gridSize: 15,
        cellSize: 0,
        board: [],
        currentPlayer: 1,
        winner: null,
        mode: '',
        socket: null,
        pvePlayerColor: 0,
        room: '',
        myPlayer: 0,
        user: {},
        currentRound: 1,
        blackName: '',
        whiteName: '',
        opponentStatus: 'online',
        offlineCountdown: 60,
        offlineTimer: null,
        opponent_id: 0,
        restartWaiting: false,
        firstChar: '',
        show: false,
        // 添加倒计时相关属性
        countdown: 30,
        countdownTimer: null,
        isCounting: false,
        showPropConfirmPopup: false,
        propUsed: false, // 是否已使用道具
        usingProp: false, // 正在请求中，防止重复点击
        propnum: 0,
        urid: null,
        token: null,
        propAlertVisible: false,
        propruleinfo: false,
      }
    },
    mounted() {
      const userStr = localStorage.getItem('user')
      if (userStr) {
        this.user = JSON.parse(userStr)
        this.firstChar = this.user.username.charAt(0);
      }
      const userInfoStr = localStorage.getItem('userinfo');
      console.log(userInfoStr,'userInfoStr');
      if (userInfoStr) {
        try {
          const userInfo = JSON.parse(userInfoStr);
          this.urid = userInfo.urid;
          this.token = userInfo.token;
        } catch (e) {
          console.error('解析用户信息失败:', e);
        }
      }

      this.mode = this.$route.query.mode || 'pve'
      if (this.mode === 'pve') {
        this.pvePlayerColor = parseInt(this.$route.query.color) || 1
        if (this.pvePlayerColor === 1) {
          this.blackName = this.user.username
          this.whiteName = "AI小步"
        } else {
          this.blackName = "AI小步"
          this.whiteName = this.user.username
        }
        axios.post('/gapi/api/create_table_pve', { username: this.user.username, user_id: this.user.id })
          .then(res => {
            this.room = res.data.table_id
            this.currentRound = res.data.current_round
          })
          .catch(err => console.error(err))
      } else if (this.mode === 'pvp') {
        this.room = this.$route.query.room
        this.myPlayer = parseInt(this.$route.query.player)
        if (this.myPlayer === 1) {
          this.blackName = this.user.username
          this.whiteName = "等待中"
        } else {
          this.whiteName = this.user.username
          this.blackName = "等待中"
        }
      }
      // const vw = Math.min(window.innerWidth * 0.95, 420)
      // this.canvasSize = vw
      this.cellSize = this.canvasSize / (this.gridSize - 1)
      this.$nextTick(() => {
        this.resetBoard()
        this.getmyprops()
      })
      if (this.mode === 'pvp') {
        this.socket = io.connect('https://game.api.mvsports.cn', { transports: ['websocket'] })
        this.socket.emit('join_room', { room: this.room, username: this.user.username, player: this.myPlayer })
        this.socket.emit('sync_game_state', { room: this.room })
        this.socket.on('sync_state', (data) => {
          if (data.moves && Array.isArray(data.moves)) {
            data.moves.forEach(move => {
              this.placePiece(move.x, move.y, move.player, false)
            })
          }
          this.currentRound = data.current_round
          if (this.myPlayer === 1) {
            this.blackName = this.user.username
            if (data.opponent_username && data.opponent_username !== "") {
              this.whiteName = data.opponent_username
              this.opponent_id = data.opponent_player_id
            }
          } else {
            this.whiteName = this.user.username
            if (data.host_username && data.host_username !== "") {
              this.blackName = data.host_username
              this.opponent_id = data.host_player_id
            }
          }
        })
        this.socket.on('startGame', (data) => {
          if (this.myPlayer === 1) {
            this.blackName = this.user.username
            this.whiteName = data.opponent
            this.opponent_id = data.opponent_id
          } else {
            this.whiteName = this.user.username
            this.blackName = data.opponent
            this.opponent_id = data.opponent_id
          }
        })
        this.socket.on('move', (data) => {
          if (data.player !== this.myPlayer) {
            this.placePiece(data.x, data.y, data.player, false)
          }
        })
        this.socket.on('gameOver', (data) => {
          this.winner = data.winner === 1 ? '黑棋' : '白棋'
        })
        this.socket.on('player_offline', (data) => {
          if (data.player_sid && data.player_sid !== this.socket.id) {
            this.opponentStatus = 'offline'
            this.startOfflineCountdown()
          }
        })
        this.socket.on('player_online', (data) => {
          if (data.player_sid && data.player_sid !== this.socket.id) {
            this.opponentStatus = 'online'
            this.clearOfflineCountdown()
          }
        })
        this.socket.on('restart_confirmed', (data) => {
          if (data.room === this.room) {
            this.currentRound = data.round_number
            this.restartWaiting = false
            this.resetBoard()
          }
        })
        setTimeout(() => {
          if ((this.myPlayer === 1 && this.whiteName === "等待对手加入…") ||
              (this.myPlayer === 2 && this.blackName === "等待对手加入…")) {
            this.socket.emit('sync_game_state', { room: this.room })
          }
        }, 2000)
      }
      if (this.mode === 'pve' && this.pvePlayerColor === 2) {
        setTimeout(this.aiMove, 500)
      }

      this.share()
    },
    methods: {
      getmyprops() { 
        axios.get('/mapi/game/myprops', {
          params: {
            urid: this.urid,
            token: this.token,
          }
        })
        .then(res => {
          if(res.status == 200){
            this.propnum = res.data.data[0].total
          }
        })
      },
      // 打开道具确认弹窗
      showPropConfirm() {
        if (this.currentPlayer !== this.myPlayer) {
          this.$dialog({ message: '仅能在自己回合使用道具哦～' });
          return
        }
        this.showPropConfirmPopup = true;
      },
      showproprule() {
        this.propruleinfo = !this.propruleinfo
      },  
      // 使用道具
      async confirmUseProp() {
        if (this.usingProp) return;
        if (this.currentPlayer !== this.myPlayer) {
          this.$dialog({ message: '仅能在自己回合使用道具哦～' });
          this.showPropConfirmPopup = false;
          return
        }
        this.usingProp = true;

        try {
          const res = await axios.post('/mapi/game/useprop', {
            urid: this.urid,
            token: this.token,
            table_id: this.room,
            round: this.currentRound,
            proptype: 1
          });

          if (res.status == 200) {
            this.propUsed = true;
            this.$dialog({ message: '道具使用成功！' });
            this.getmyprops()
          } else {
            this.$dialog({ message: '使用失败，请重试' });
          }
        } catch (err) {
          console.error(err);
          this.$dialog({ message: '网络错误' });
        } finally {
          this.usingProp = false;
          this.showPropConfirmPopup = false;
        }
      },

      // 检查是否被使用了道具
      async checkPropStatus() {
        if (this.currentPlayer == this.myPlayer) {
          return false;
        }
        // if (1) {
        if (this.urid && this.token) {
          try{
            const res = await axios.post('/mapi/game/queryprop', {
              urid: this.urid,
              token: this.token,
              // urid: 924639,
              // token: 'PR45x8wiDLuB7wA1u7hSIRi2F75W9uA-',
              table_id: this.room,
              round: this.currentRound
            });
            if (res.status == 200 && res.data.data.flag == 1) {
              this.propUsed = true;
              // this.countdown = 15;
              this.propAlertVisible = true;
              setTimeout(() => {
                this.propAlertVisible = false;
              }, 2000);
              console.log('被使用了道具');
              return true;
            } else {
              console.log('道具未使用');
              return false;
            }
          }
          catch (err) {
            console.error('查询道具失败:', err);
            return false;
          };
        } else {
          console.error('用户信息不存在');
          return false;
        }
      },
      share() {
        var url = 'https://game.gomoku.mvsports.cn/mode'
          var shareConf = {
            title: '桌台大厅',
            path:
              '/pages/webview/index?src=' + url,
          }
          wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) });
      },
      // 添加倒计时相关方法
      async startCountdown() {
        if (this.mode !== 'pvp') return;
        const isPropUsed = await this.checkPropStatus();
        console.log('123456:', isPropUsed);
        // 根据是否使用道具决定初始时间
        if (this.propUsed || isPropUsed) {
          this.countdown = 15;
          this.propUsed = false;
          console.log('开始倒计时15秒');
        } else {
          this.countdown = 30;
        }
        this.isCounting = true;

        this.countdownTimer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            this.stopCountdown();
            this.handleTimeout();
          }
        }, 1000);
      },
      stopCountdown() {
        if (this.countdownTimer) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
        }
        this.isCounting = false
      },
      handleTimeout() {
        // 只在玩家自己的回合超时时才自动下棋
        if (this.mode === 'pvp' && this.currentPlayer === this.myPlayer) {
          // 使用简单的AI逻辑来自动落子
          let bestScore = -1;
          let bestMoves = [];
          
          // 使用当前玩家的颜色
          let playerColor = this.currentPlayer;
          
          for (let i = 0; i < this.gridSize; i++) {
            for (let j = 0; j < this.gridSize; j++) {
              if (this.board[i][j] === 0) {
                let attackScore = this.evaluateMove(j, i, playerColor);
                let defenseScore = this.evaluateMove(j, i, playerColor === 1 ? 2 : 1);
                let totalScore = Math.max(attackScore, defenseScore);
                if (totalScore > bestScore) {
                  bestScore = totalScore;
                  bestMoves = [{ x: j, y: i }];
                } else if (totalScore === bestScore) {
                  bestMoves.push({ x: j, y: i });
                }
              }
            }
          }
          
          let move;
          if (bestMoves.length > 0) {
            move = bestMoves[Math.floor(Math.random() * bestMoves.length)];
          } else {
            // 如果找不到合适的移动位置，随便找一个空位
            for (let i = 0; i < this.gridSize; i++) {
              for (let j = 0; j < this.gridSize; j++) {
                if (this.board[i][j] === 0) {
                  move = { x: j, y: i };
                  break;
                }
              }
              if (move) break;
            }
          }
          
          // 如果找到了移动位置，模拟用户点击事件
          if (move) {
            // 计算点击位置的坐标
            const rect = this.$refs.canvas.getBoundingClientRect();
            const cellSize = this.cellSize;
            
            // 创建一个模拟的点击事件对象
            const simulatedEvent = {
              clientX: rect.left + move.x * cellSize,
              clientY: rect.top + move.y * cellSize
            };
            
            // 调用handleClick
            this.handleClick(simulatedEvent);
          }
        }
      },
      resetBoard() {
        this.board = []
        for (let i = 0; i < this.gridSize; i++) {
          let row = []
          for (let j = 0; j < this.gridSize; j++) {
            row.push(0)
          }
          this.board.push(row)
        }
        this.currentPlayer = 1
        this.show = false
        this.winner = null
        this.stopCountdown()
        this.drawBoard()
      },
      resetGame() {
        if (this.mode === 'pvp' && this.socket) {
          this.socket.disconnect()
          this.socket = null
        }
        this.resetBoard()
      },
      handleClick(event) {
        if (this.winner) return
        const rect = this.$refs.canvas.getBoundingClientRect()
        const x = event.clientX - rect.left
        const y = event.clientY - rect.top
        const i = Math.round(y / this.cellSize)
        const j = Math.round(x / this.cellSize)
        if (i < 0 || i >= this.gridSize || j < 0 || j >= this.gridSize) return
        if (this.board[i][j] !== 0) return
        if (this.mode === 'pvp') {
          if (this.currentPlayer !== this.myPlayer) return
          this.socket.emit('move', { room: this.room, x: j, y: i, player: this.currentPlayer })
        }
        if (this.mode === 'pve') {
          if (this.currentPlayer !== this.pvePlayerColor) return
        }
        this.placePiece(j, i, this.currentPlayer, true)
        if (this.mode === 'pve' && this.currentPlayer !== this.pvePlayerColor && !this.winner) {
          setTimeout(this.aiMove, 500)
        }
      },
      placePiece(x, y, player, localUpdate) {
        if (this.board[y][x] !== 0) return
        if (player === 1 && this.isForbiddenMove(x, y)) {
          alert("禁手：该位置不允许落子！")
          return
        }
        this.board[y][x] = player
        this.drawBoard()
        this.stopCountdown()
        // 检查是否是首次落子
        let hasMove = this.board.some(row => row.some(cell => cell !== 0));
        if (!hasMove || this.winner) {
          this.startCountdown()
        } else {
          // 非首次落子，停止当前倒计时并重新启动
          this.stopCountdown()
          this.startCountdown()
        }
        if (this.checkWin(x, y, player)) {
          this.show = true
          this.winner = player === 1 ? '黑棋' : '白棋'
          let winner_id = 0
          if (this.mode === 'pvp') {
            winner_id = ((this.winner === '黑棋' && this.myPlayer === 1) || (this.winner === '白棋' && this.myPlayer === 2))
                        ? this.user.id : (this.opponent_id || 0)
          } else {
            winner_id = (this.winner === '黑棋' && this.pvePlayerColor === 1) || (this.winner === '白棋' && this.pvePlayerColor === 2)
                        ? this.user.id : 0
          }
          axios.post('/gapi/api/game-result', { 
            winner: this.winner, 
            user_id: this.user.id,
            user: this.user.username,
            winner_id: winner_id,
            table_id: this.room,
            round_number: this.currentRound
          })
          if (this.mode === 'pvp' && this.socket) {           
            this.socket.emit('gameOver', { room: this.room, winner: player })
          }
        } else {
          this.currentPlayer = (player === 1 ? 2 : 1)
          // 启动新的倒计时
          let hasMove = this.board.some(row => row.some(cell => cell !== 0));
          if (!hasMove || this.winner) {
            if (this.mode === 'pvp') {
              this.startCountdown()
            }
          }
        }
      },
      drawBoard() {
        const ctx = this.$refs.canvas.getContext('2d')
        ctx.clearRect(0, 0, this.canvasSize, this.canvasSize)
        ctx.fillStyle = '#E4D3B0'
        ctx.fillRect(0, 0, this.canvasSize, this.canvasSize)
        ctx.strokeStyle = '#B28E75'
        ctx.lineWidth = 1.5
        for (let i = 0; i < this.gridSize; i++) {
          ctx.beginPath()
          ctx.moveTo(0.5, i * this.cellSize + 0.5)
          ctx.lineTo(this.canvasSize - 0.5, i * this.cellSize + 0.5)
          ctx.stroke()
          ctx.beginPath()
          ctx.moveTo(i * this.cellSize + 0.5, 0.5)
          ctx.lineTo(i * this.cellSize + 0.5, this.canvasSize - 0.5)
          ctx.stroke()
        }
        for (let i = 0; i < this.gridSize; i++) {
          for (let j = 0; j < this.gridSize; j++) {
            if (this.board[i][j] !== 0) {
              const stoneX = j * this.cellSize
              const stoneY = i * this.cellSize
              const stoneRadius = this.cellSize / 2 - 2
              ctx.save()
              ctx.beginPath()
              ctx.arc(stoneX, stoneY, stoneRadius, 0, Math.PI * 2)
              ctx.shadowOffsetX = 2
              ctx.shadowOffsetY = 2
              ctx.shadowBlur = 4
              ctx.shadowColor = 'rgba(0,0,0,0.5)'
              let gradient
              if (this.board[i][j] === 1) {
                gradient = ctx.createRadialGradient(stoneX - stoneRadius/3, stoneY - stoneRadius/3, stoneRadius/5, stoneX, stoneY, stoneRadius)
                gradient.addColorStop(0, '#555')
                gradient.addColorStop(1, '#000')
                ctx.fillStyle = gradient
                ctx.fill()
                ctx.strokeStyle = '#000'
                ctx.stroke()
              } else {
                // 白棋：只填充，不描边
                gradient = ctx.createRadialGradient(stoneX - stoneRadius/3, stoneY - stoneRadius/3, stoneRadius/5, stoneX, stoneY, stoneRadius)
                gradient.addColorStop(0, '#fff')
                gradient.addColorStop(1, '#ddd')
                ctx.fillStyle = gradient
                ctx.fill()
              }
              ctx.restore()
            }
          }
        }
      },
      checkWin(x, y, player) {
        const directions = [
          { dx: 1, dy: 0 },
          { dx: 0, dy: 1 },
          { dx: 1, dy: 1 },
          { dx: 1, dy: -1 }
        ]
        for (let d of directions) {
          let count = 1
          let i = 1
          while (this.getPiece(x + d.dx * i, y + d.dy * i) === player) {
            count++
            i++
          }
          i = 1
          while (this.getPiece(x - d.dx * i, y - d.dy * i) === player) {
            count++
            i++
          }
          if (count >= 5) return true
        }
        return false
      },
      getPiece(x, y) {
        if (x < 0 || x >= this.gridSize || y < 0 || y >= this.gridSize) return null
        return this.board[y][x]
      },
      aiMove() {
        let aiColor = this.pvePlayerColor === 1 ? 2 : 1
        let opponentColor = this.pvePlayerColor
        let bestScore = -1
        let bestMoves = []
        for (let i = 0; i < this.gridSize; i++) {
          for (let j = 0; j < this.gridSize; j++) {
            if (this.board[i][j] === 0) {
              let attackScore = this.evaluateMove(j, i, aiColor)
              let defenseScore = this.evaluateMove(j, i, opponentColor)
              let totalScore = Math.max(attackScore, defenseScore)
              if (totalScore > bestScore) {
                bestScore = totalScore
                bestMoves = [{ x: j, y: i }]
              } else if (totalScore === bestScore) {
                bestMoves.push({ x: j, y: i })
              }
            }
          }
        }
        if (bestMoves.length > 0) {
          let move = bestMoves[Math.floor(Math.random() * bestMoves.length)]
          this.placePiece(move.x, move.y, aiColor, true)
        }
      },
      evaluateMove(x, y, color) {
        if (this.mode === 'pve' && this.pvePlayerColor === 2 && color === 1) {
            if (this.isForbiddenMove(x, y)) {
                return -100000;
            }
        }
        this.board[y][x] = color
        let score = this.scorePosition(x, y, color)
        this.board[y][x] = 0
        return score
      },
      scorePosition(x, y, color) {
        let score = 0
        const directions = [
          { dx: 1, dy: 0 },
          { dx: 0, dy: 1 },
          { dx: 1, dy: 1 },
          { dx: 1, dy: -1 }
        ]
        for (let d of directions) {
          let count = this.countContinuous(x, y, d.dx, d.dy, color) +
                      this.countContinuous(x, y, -d.dx, -d.dy, color) - 1
          if (count >= 5) score += 10000
          else if (count === 4) score += 1000
          else if (count === 3) score += 100
          else if (count === 2) score += 10
        }
        return score
      },
      countContinuous(x, y, dx, dy, color) {
        let count = 0
        let i = 0
        while (true) {
          let nx = x + i * dx
          let ny = y + i * dy
          if (nx < 0 || nx >= this.gridSize || ny < 0 || ny >= this.gridSize) break
          if (this.board[ny][nx] === color) {
            count++
            i++
          } else {
            break
          }
        }
        return count
      },
      isForbiddenMove(x, y) {
        if (this.currentPlayer !== 1) return false
        this.board[y][x] = 1
        const directions = [
          { dx: 1, dy: 0 },
          { dx: 0, dy: 1 },
          { dx: 1, dy: 1 },
          { dx: 1, dy: -1 }
        ]
        let overline = false
        let openThreeCount = 0
        let openFourCount = 0
        for (let d of directions) {
          let countForward = 0
          let i = 1
          while (this.getPiece(x + d.dx * i, y + d.dy * i) === 1) {
            countForward++
            i++
          }
          let countBackward = 0
          i = 1
          while (this.getPiece(x - d.dx * i, y - d.dy * i) === 1) {
            countBackward++
            i++
          }
          let count = 1 + countForward + countBackward
          if (count >= 6) overline = true
          let forwardEnd = this.getPiece(x + d.dx * (countForward + 1), y + d.dy * (countForward + 1))
          let backwardEnd = this.getPiece(x - d.dx * (countBackward + 1), y - d.dy * (countBackward + 1))
          if (count === 3 && forwardEnd === 0 && backwardEnd === 0) openThreeCount++
          if (count === 4 && (forwardEnd === 0 || backwardEnd === 0)) openFourCount++
        }
        this.board[y][x] = 0
        if (overline) return true
        if (openThreeCount >= 2) return true
        if (openFourCount >= 2) return true
        return false
      },
      startOfflineCountdown() {
        if (this.offlineTimer) return
        this.offlineCountdown = 60
        this.offlineTimer = setInterval(() => {
          this.offlineCountdown--
          if (this.offlineCountdown <= 0) {
            clearInterval(this.offlineTimer)
            this.offlineTimer = null
            this.show = true
            this.winner = this.myPlayer === 1 ? '黑棋' : '白棋'
            if (this.socket) {              
              this.socket.emit('gameOver', { room: this.room, winner: this.myPlayer })
            }
            axios.post('/gapi/api/game-result', { 
              winner: this.winner, 
              user_id: this.user.id,
              user: this.user.username,
              winner_id: (this.myPlayer === 1 ? this.user.id : this.opponent_id || 0),
              table_id: this.room,
              round_number: this.currentRound
            })
          }
        }, 1000)
      },
      clearOfflineCountdown() {
        if (this.offlineTimer) {
          clearInterval(this.offlineTimer)
          this.offlineTimer = null
          this.offlineCountdown = 60
        }
      },
      goBack() {
        // 检查是否有落子
        let hasMove = this.board.some(row => row.some(cell => cell !== 0));
        if (!hasMove || this.winner) {
          this.show = true
          // 没有落子或比赛已结束，直接返回并更新桌台状态为 finished
          if (this.mode === 'pvp' && this.socket) {    
            this.socket.emit('gameOver', { room: this.room, winner: this.myPlayer });
          } else if (this.mode === 'pve') {
            if(hasMove) {
              axios.post('/gapi/api/game-result', { 
                winner: this.user.username, 
                user_id: this.user.id,
                user: this.user.username,
                winner_id: this.user.id,
                table_id: this.room,
                round_number: this.currentRound
              });
            }
            // 更新桌台状态为 finished
            axios.post('/gapi/api/finish_table', { table_id: this.room });
          }
          this.$router.push('/mode');
        } else {
          if (confirm("比赛正在进行，确定退出吗？退出将视为离线判负")) {
            if (this.mode === 'pve') {
              this.winner = this.myPlayer === 1 ? '黑棋' : '白棋';
              axios.post('/gapi/api/game-result', { 
                winner: this.winner, 
                user_id: this.user.id,
                user: this.user.username,
                winner_id: (this.myPlayer === 1 ? this.user.id : 0),
                table_id: this.room,
                round_number: this.currentRound
              });
              axios.post('/gapi/api/finish_table', { table_id: this.room })
                .then(() => {
                  this.$router.push('/mode');
                })
                .catch(err => {
                  console.error(err);
                  this.$router.push('/mode');
                });
            } else {
              // PvP 模式直接返回（离线判负由对手超时处理）
              this.socket.disconnect()
              this.$router.push('/mode');
            }
          }
        }
      },
      restart() {
        if (this.mode === 'pvp' && this.socket) {
          if (this.opponentStatus === 'offline') {
            this.$dialog({message:"对方已离线"});
            return;
          }

          this.restartWaiting = true;
          this.socket.emit('restart_game', { room: this.room, username: this.user.username });
        } else if (this.mode === 'pve') {
          axios.post('/gapi/api/restart_table_pve', { table_id: this.room })
            .then(res => {
              this.currentRound = res.data.current_round;
              this.resetBoard();
              // 如果玩家选白（pvePlayerColor == 2），则机器继续执黑先走
              if (this.pvePlayerColor === 2 && this.currentPlayer === 1) {
                setTimeout(this.aiMove, 500)
            }
            })
            .catch(err => {
              console.error(err);
              this.resetBoard();
            });
        } else {
          this.resetBoard();
        }
      }
    },
    beforeDestroy() {
      // 组件销毁前断开socket连接
      if (this.socket) {
        this.socket.disconnect();
        this.socket = null;
      }
      
      // 清理离线倒计时器
      if (this.offlineTimer) {
        clearInterval(this.offlineTimer);
        this.offlineTimer = null;
      }
      // 清理游戏倒计时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    }
  }
  </script>
  
  <style scoped>
  .game-board {
    text-align: center;
    padding: 200px 0 0;
    background: url(https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/bk3.png) no-repeat;
    background-size: cover;
    min-height: 100vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }
  .game-board .back-arrow {
    position: absolute;
    background: url(https://oss.mcloud.moveclub.cn/2025/back.png) no-repeat;
    background-size: 100%;
    top: 10px;
    left: 10px;
    width: 44px;
    height: 44px;
    z-index: 10;
  }
  .arrow-icon {
    color: #000;
  }
  .game-board .header {
    width: 100%;
    margin-bottom: 6px;
    font-size: 4vw;
  }
  .game-board .player-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1vh;
    padding: 0 12px;
    position: relative;
  }
  .game-board .player {
    font-weight: bold;
    width: 72px;
    height: 72px;
    border-radius: 50%;
  }
  .game-board .puser{
    background: #ffffff;
    text-align: center;
    font-size: 28px;
    color: #000;
    line-height: 72px;
  }
  .game-board .ai{
    background: url(https://oss.mcloud.moveclub.cn/2025/morentouxiang.png) no-repeat;
    background-size: 100%;
  }
  .player-card {
    width: 114px;
    padding: 8px;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    text-align: center;
    position: relative;
  }
  .pvpvs{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 58px;
    height: 58px;
  }
  .player-card .playtop{
    display: flex;
  }
  .playtop .playright{ 
    padding: 4px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .black-player {
    background-image: linear-gradient(90deg, #D7F2EA 1%, #ECF9F4 100%);
    border: 4px solid rgba(81,191,204,1);
    border-radius: 14px;
    color: #479599;
  }

  .white-player {
    background-image: linear-gradient(270deg, #FBF7EC 0%, #F6EBD4 100%);
    border: 4px solid rgba(254,152,96,1);
    border-radius: 14px;
    color: #7B483E;
  }

  .avatar-container {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    overflow: hidden;
    margin: 0 auto 10px;
    /* border: 2px solid #fff; */
  }

  .avatar-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .player-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .player-color {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin-bottom: 8px;
  }

  .color-dot {
    width: 14px;
    height: 14px;
  }

  .black-dot {
    background: url(https://oss.mcloud.moveclub.cn/2025/heiqi.png) no-repeat;
    background-size: cover;
  }

  .white-dot {
    background: url(https://oss.mcloud.moveclub.cn/2025/baiqi.png) no-repeat;
    background-size: cover;
  }

  .countdown {
    font-size: 14px;
  }
  .vs {
    width: 65px;
    height: 80px;
    background: url(https://oss.mcloud.moveclub.cn/2025/hu_game/wuziqi/VS.png) no-repeat;
    background-size: 100%;
  }
  .round-status {
    margin-bottom: 1vh;
  }
  /* 添加倒计时样式 */
  .countdown-display {
    height: 20px;
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .my-countdown {
    color: #4CAF50;
    font-weight: bold;
  }
  .opponent-countdown {
    color: #F44336;
    font-weight: bold;
  }
  .status-info {
    text-align: center;
    color: rgba(146, 62, 8, 1);
    font-size: 18px;
    /* margin-bottom: 1vh; */
    margin-top: 5px;
    position: absolute;
    bottom: 9%;
  }
  .status-indicator {
    display: inline-block;
    width: 3vw;
    height: 3vw;
    border-radius: 50%;
    margin-left: 1vw;
  }
  .status-indicator.online {
    background-color: green;
  }
  .status-indicator.offline {
    background-color: red;
  }
  .board-container {
    background: url(https://oss.mcloud.moveclub.cn/2025/qipan.png) no-repeat;
    width: 359px;
    height: 450.43px;
    background-size: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 52px 15px 0;
    position: relative;
  }
  .board-container .players {
    position: absolute;
    top: 8px;
    left: 84px;
    font-size: 14px;
    color: #ffffff;
    display: flex;
  }
  .board-container .players>div{
    width: 88px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    position: relative;
  }
  .board-container .players>div:nth-child(2){
    margin-left: 16px;
  }
  .board-container .players .b::before{
    position: absolute;
    content: ' ';
    background: url(https://oss.mcloud.moveclub.cn/2025/heiqi.png) no-repeat;
    background-size: 100%;
    width: 18px;
    height: 18px;
    left: -29px;
    top: 5px;
    opacity: 1;
  }
  .board-container .players .w::after{
    position: absolute;
    content: ' ';
    background: url(https://oss.mcloud.moveclub.cn/2025/baiqi.png) no-repeat;
    background-size: 100%;
    width: 18px;
    height: 18px;
    right: -29px;
    top: 5px;
    opacity: 1;
  }
  .board-container .players .b.active::before{
    animation: flash 1s infinite;
  }
  .board-container .players .w.active::after{
    animation: flash 1s infinite;
  }
  .board-container .players .b2::before{
    position: absolute;
    content: ' ';
    background: url(https://oss.mcloud.moveclub.cn/2025/baiqi.png) no-repeat;
    background-size: 100%;
    width: 18px;
    height: 18px;
    left: -29px;
    top: 5px;
    opacity: 1;
  }
  .board-container .players .w2::after{
    position: absolute;
    content: ' ';
    background: url(https://oss.mcloud.moveclub.cn/2025/heiqi.png) no-repeat;
    background-size: 100%;
    width: 18px;
    height: 18px;
    right: -29px;
    top: 5px;
    opacity: 1;
  }
  .board-container .players .b2.active::before{
    animation: flash 1s infinite;
  }
  .board-container .players .w2.active::after{
    animation: flash 1s infinite;
  }

  @keyframes flash {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
  }
  canvas {
    width: 100%;
    height: auto;
    background: #E4D3B0;
    border: 0.5vw solid #B28E75;
    box-shadow: 0.5vw 0.5vw 1vw rgba(0,0,0,0.3);
    touch-action: manipulation;
  }
  .result {
    margin-top: 10px;
  }
  button {
    width: 164px;
    height: 38px;
    background: url(https://oss.mcloud.moveclub.cn/2025/buttton.png) no-repeat;
    background-size: 100%;
    border-color: transparent !important;
    border-width: 0px !important;
  }
  button.disabled {
    background: url(https://oss.mcloud.moveclub.cn/2025/bt2.png) no-repeat;
    width: 164px;
    height: 38px;
    background-size: 100%;
    border-color: transparent !important;
    border-width: 0px !important;
  }
  .pop{
    width: 263px;
    height: 280px;
    box-sizing: border-box;
  }
  .confirm-popup {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: linear-gradient(145deg, #f0f0f0, #ffffff);
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
  .popup-header {
    padding: 16px;
    text-align: center;
    /* background: linear-gradient(to right, #ff8917d1, #ff8917de); */
    color: #333333;
  }
  .popup-header h3 {
    margin: 0;
    font-weight: 600;
    font-size: 18px;
  }
  .popicon{
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .popup-content {
    padding: 14px 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .popup-content p {
    margin: 4px 0;
    font-size: 16px;
    color: #333;
  }
  .popup-footer {
    display: flex;
    padding: 0 20px 20px;
    gap: 10px;
  }
  .popup-footer button {
    flex: 1;
    border: none;
    border-radius: 16px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  .cancel-btn {
    background: #f1f1f1;
    color: #666;
  }
  .cancel-btn:hover {
    background: #e0e0e0;
  }
  .confirm-btn {
    background: #97C867;
    color: white;
  }
  .confirm-btn:hover:not(.disabled) {
    opacity: 0.9;
    transform: translateY(-2px);
  }
  .confirm-btn.disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
  .prop-icon {
    position: absolute;
    top: 154px;
    right: 32px;
    cursor: pointer;
    z-index: 10;
  }
  .prop-icon2 {
    position: absolute;
    top: 162px;
    right: 10px;
    cursor: pointer;
    z-index: 10;
  }
  .prop-icon .propnum { 
    position: absolute;
    top: 50%;
    transform: translate(0%, -65%);
    right: 4px;
    font-size: 14px;
  }
  .prop-alert {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 20px 30px;
    border-radius: 10px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }
  
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  </style>
  